import React, { useEffect, useState } from "react";
import allApi from "../../../../api/allApi";
import errorIcon from "../../../../assets/images/error-2.png";
import { useLocalization } from "../../localization/LocalizationContext";
import { Modal,Button } from "react-bootstrap";

function TrafficShaping({ networkId }) {
  const {localizationStrings} = useLocalization();
  const [trafficShaping,setTrafficShaping] = useState(); 
  const [networkIds, setNetworkIds] = useState([]);
  //const [networkId, setNetworkId] = useState("6001");
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [showModal, setShowModal] = useState(false); 
  const [pendingStatus, setPendingStatus] = useState(null); 
  const [trafficValues,setTrafficValues] = useState({
  wlan0Support: 0,
  wlan0Status: 0,
  wlan1Support: 0,
  wlan1Status: 0,
  wlan2Support: 0,
  wlan2Status: 0,
  }); 
  

  useEffect(() => {
    if (networkId) 
      getTrafficShaping();
  }, [networkId]);
  useEffect(() => {
      fetchNetworkIds();
    }, []);

   const fetchNetworkIds = async () => {
    try {
      const api = new allApi();
      const response = await api.getRequest("api/network/getAssociatedNetwork");
      if (
        response &&
        response.status === "OK" &&
        Array.isArray(response.response)
      ) {
        setNetworkIds(
        response.response.map((network) => ({
          network_id: network.network_id,
          network_name: network.network_name,
        }))
      );
      }
    } catch (error) {
      console.error("Error fetching network IDs:", error);
    }
  };  

 const getTrafficShaping = async () => {
    try {
      const api = new allApi();
      const response = await api.getRequest(`api/wireless/qos?networkId=${networkId}`);

      if (response?.status === "200" && response.data) {
        const { wlan0Support, wlan0Status, wlan1Support, wlan1Status } = response.data;
        setTrafficValues({ wlan0Support, wlan0Status, wlan1Support, wlan1Status });
      }
    } catch (error) {
      console.error("Error fetching traffic shaping:", error);
    }
  };

   const inputTrafficShaping = async (updatedValues) => {
    try {
      const api = new allApi();
      const payload = {
        networkId,
        wlan0Support: updatedValues.wlan0Support,
        wlan0Status: updatedValues.wlan0Status,
        wlan1Support: updatedValues.wlan1Support,
        wlan1Status: updatedValues.wlan1Status,
        wlan2Support: 0,
        wlan2Status: 0,
      };

      const response = await api.postRequest("api/wireless/qos", "", payload);

      if (response?.status === "200") {
        console.log("Traffic shaping updated successfully");
        setTrafficValues(updatedValues);
        setShowSuccessPopup(true);
      }
    } catch (error) {
      console.error("Error updating traffic shaping:", error);
    }
  };

  const handleToggle = (field) => {
    const newValues = { ...trafficValues, [field]: trafficValues[field] ? 0 : 1 };
    setTrafficValues(newValues);
  //  inputTrafficShaping(newValues);
  };

  const handleModalConfirm = () => {
    setShowModal(false);
    if (pendingStatus !== null) {
      inputTrafficShaping(pendingStatus);
      setPendingStatus(null);
    }
  };

  const handleCancelPopUp = () => {
    setShowSuccessPopup(false);
    getTrafficShaping(networkId);
  }

  return (
    <div>
      {/* 2.4 GHz Section */}
      <div className="tab-form mt-3">
        <div className="row align-items-center mb-2">
          <div className="col-auto">
            <label>2.4 GHz</label>
          </div>
        </div>

        <div className="row mt-4">
          <div className="col-lg-4">
            <div className="switch-box">
              <strong>{localizationStrings?.support}</strong>
              <label className="ice-switch">
                <input
                  type="checkbox"
                  checked={trafficValues.wlan0Support === 1}
                  onChange={() => handleToggle("wlan0Support")}
                />
                <span className="slider"></span>
              </label>
            </div>
          </div>
        </div>

        <div className="row mt-4">
          <div className="col-lg-4">
            <div className="switch-box">
              <strong>{localizationStrings?.status}</strong>
              <label className="ice-switch">
                <input
                  type="checkbox"
                  checked={trafficValues.wlan0Status === 1}
                  onChange={() => handleToggle("wlan0Status")}
                />
                <span className="slider"></span>
              </label>
            </div>
          </div>
        </div>
      </div>

      {/* 5 GHz Section */}
      <div className="tab-form mt-3">
        <div className="row align-items-center mb-2">
          <div className="col-auto">
            <label>5 GHz</label>
          </div>
        </div>

        <div className="row mt-4">
          <div className="col-lg-4">
            <div className="switch-box">
              <strong>{localizationStrings?.support}</strong>
              <label className="ice-switch">
                <input
                  type="checkbox"
                  checked={trafficValues.wlan1Support === 1}
                  onChange={() => handleToggle("wlan1Support")}
                />
                <span className="slider"></span>
              </label>
            </div>
          </div>
        </div>

        <div className="row mt-4">
          <div className="col-lg-4">
            <div className="switch-box">
              <strong>{localizationStrings?.status}</strong>
              <label className="ice-switch">
                <input
                  type="checkbox"
                  checked={trafficValues.wlan1Status === 1}
                  onChange={() => handleToggle("wlan1Status")}
                />
                <span className="slider"></span>
              </label>
            </div>
          </div>
        </div>
      </div>

      {/* Footer Buttons */}
      <div className="wifi-footer">
        <button type="button" className="btn btn-outline">
          {localizationStrings?.cancel}
        </button>
        <button type="submit" className="text-btn primary-btn" onClick={() => inputTrafficShaping(trafficValues)}>
          {localizationStrings?.save}
        </button>
      </div>

      {/* Confirmation Modal */}
      {/* {showModal && (
        <div className="customModal confirm-modal">
          <div className="modal-dialog modal-dialog-centered small">
            <div className="modal-content inc-modal">
              <div className="modal-body">
                <img src={errorIcon} alt="error" />
                <p>{localizationStrings?.disableRoamingInfo}</p>
                <h3>{localizationStrings?.continueMsg}</h3>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-outline"
                    onClick={handleModalCancel}
                  >
                    {localizationStrings?.no}
                  </button>
                  <button
                    className="text-btn primary-btn"
                    onClick={handleModalConfirm}
                  >
                    {localizationStrings?.yes}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )} */}
       <Modal
        show={showSuccessPopup}
        onHide={handleCancelPopUp}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="inc-alert index-2000"
      >
        <span className="success-icon">
          <i className="icon done"></i>
        </span>
        <h3>{localizationStrings?.success}</h3>
        <p>{localizationStrings?.trafficShapingUpdatedSuccessfully}</p>
        <Button onClick={handleCancelPopUp}>
          {localizationStrings?.ok}
        </Button>
      </Modal>
    </div>
  );
}

export default TrafficShaping;
